import {
  ChipCounterList,
  Column,
  ColumnType,
  InternalLink,
  StatusChip,
} from '@elementary/common-ui/components';
import dateRenderer from '@elementary/common-ui/components/cellRenderers/dateRenderer';
import dateComparer from '@elementary/common-ui/utils/comparers/dateComparer';
import { Typography } from '@mui/material';
import { formatRelativeTime } from '@elementary/common-ui/utils/datetime';
import { RUNTIME_HEALTH_CHIP_STATUS, RUNTIMES_BASE_PATH } from '../constants';
import { Runtime } from '../types';

const useRuntimesColumns = () => {
  const columns: Column<Runtime>[] = [
    {
      id: 'name',
      header: 'Name',
      filterable: false,
      renderer: (runtime) => (
        <InternalLink to={`${RUNTIMES_BASE_PATH}/${runtime.id}`}>
          {runtime.name}
        </InternalLink>
      ),
      compareFunc: (a, b) => a.name.localeCompare(b.name),
    },
    {
      id: 'connections',
      header: 'Warehouses',
      filterable: false,
      sortable: false,
      showValueWhenEmpty: true,
      renderer: (runtime) =>
        runtime.connections.length > 0 ? (
          <ChipCounterList
            items={runtime.connections.map((connection) => connection.name)}
          />
        ) : (
          <Typography sx={{ color: 'content.disabled' }}>None yet</Typography>
        ),
    },
    {
      id: 'lastSeenAt',
      header: 'Last activity',
      filterable: false,
      showValueWhenEmpty: true,
      renderer: (runtime) => (
        <Typography>{formatRelativeTime(runtime.lastSeenAt)}</Typography>
      ),
      compareFunc: (a, b) => dateComparer(a.lastSeenAt, b.lastSeenAt),
    },
    {
      id: 'createdAt',
      header: 'Created',
      type: ColumnType.Date,
      filterable: false,
      renderer: (runtime) => dateRenderer(runtime.createdAt, 'L'),
      compareFunc: (a, b) => dateComparer(a.createdAt, b.createdAt),
    },
    {
      id: 'health',
      header: 'Status',
      width: 110,
      sticky: 'right',
      filterable: false,
      renderer: (runtime) => (
        <StatusChip status={RUNTIME_HEALTH_CHIP_STATUS[runtime.health]} />
      ),
    },
  ];

  return columns;
};

export default useRuntimesColumns;
